import React from 'react';

import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { Box, TextField } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

const Input = ({ control, label, name, type }) => (
    <Controller
        control={control}
        name={name}
        render={({ field, fieldState: { error } }) => (
            <TextField
                error={Boolean(error)}
                fullWidth
                helperText={error ? error.message : ''}
                label={
                    <Box display="flex" alignItems="center" gap={1}>
                        <MailOutlineIcon fontSize="small" /> {label}
                    </Box>
                }
                name={name}
                type={type}
                {...field}
            />
        )}
    />
);

Input.propTypes = {
    control: PropTypes.object,
    label: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
};

export default Input;
